import { z } from 'zod';
import { expectType, zDocument } from './model.js';
export const zTotalEngagementFields = z.object({
    engagement: z.object({
        likeCount: z.number(),
        readCount: z.number()
    })
});
expectType({});
expectType({});
export const zPostView = zDocument.merge(z.object({
    type: z.literal('postView'),
    postId: z.string(),
    userId: z.string(),
    viewCount: z.number()
}));
expectType({});
expectType({});
export const EmptyPostView = {
    _id: '',
    _rev: '',
    created: '',
    updated: '',
    type: 'postView',
    userId: '',
    postId: '',
    viewCount: 1
};
